const globalStoerer = document.querySelector('.global-stoerer');
if (globalStoerer) {
  if (!/global-stoerer=closed/.test(document.cookie)) {
    globalStoerer.classList.add('global-stoerer--active');
  }

  const buttons = globalStoerer.querySelector('.global-stoerer__buttons');
  if (buttons) {
    buttons.addEventListener('click', () => {
      const expires = new Date((new Date()).getTime() + (300 * 86400000));
      document.cookie = `global-stoerer=closed; expires=${expires}; path=/`;
      globalStoerer.classList.remove('global-stoerer--active');
    });
  }
}
